export default [
	{ value: "Accountant", label: "Accountant" },
	{ value: "Administrator", label: "Administrator" },
	{ value: "Athlete", label: "Athlete" },
	{ value: "Clergy", label: "Clergy" },
	{ value: "Consultant", label: "Consultant" },
	{ value: "Educator", label: "Educator" },
	{ value: "Engineer", label: "Engineer" },
	{ value: "Finance", label: "Finance" },
	{ value: "Food Service", label: "Food Service" },
	{ value: "Graphic Design", label: "Graphic Design" },
	{ value: "Health Care", label: "Health Care" },
	{ value: "Insurance", label: "Insurance" },
	{ value: "Journalist", label: "Journalist" },
	{ value: "Law Enforcement", label: "Law Enforcement" },
	{ value: "Lawyer", label: "Lawyer" },
	{ value: "Legal", label: "Legal" },
	{ value: "Management", label: "Management" },
	{ value: "Military", label: "Military" },
	{ value: "Other", label: "Other" },
	{ value: "Pilot", label: "Pilot" },
	{ value: "Real Estate / Construction", label: "Real Estate / Construction" },
	{ value: "Research", label: "Research" },
	{ value: "Retired", label: "Retired" },
	{ value: "Sales/Marketing", label: "Sales/Marketing" },
	{ value: "Technology", label: "Technology" },
	{ value: "Works at Home", label: "Works at Home" }
]